export default {
  inserted: function (el, binding) {
    // console.log(`directive: athub-permission`, binding);
    let resourcesStr = localStorage.getItem('resources');
    if (resourcesStr === null || resourcesStr === '') {
      console.warn('LocalStorage resources is empty.');
      el.parentNode.removeChild(el);
    } else {
      let resources = JSON.parse(resourcesStr);
      if (!resources.hasOwnProperty(binding.value)) {
        el.parentNode.removeChild(el);
      }
    }
  }
}